import { EventGuest } from "../../redux/features/event/event.types";
import { TicketColor } from "../../utils/types";
import { Pill } from "../pill";
import { ProfileIcon } from "./profilePic";

export const GuestCard = ({
  className,
  name,
  email,
  timeAgo,
  showTicket = true,
  hideEmailOnMobile = false,
  guest,
  ticketColor,
}: {
  className?: string;
  name: string;
  email: string;
  timeAgo?: string;
  showTicket?: boolean;
  hideEmailOnMobile?: boolean;
  guest?: EventGuest;
  ticketColor?: TicketColor;
}) => {
  return (
    <div className="flex items-start gap-1">
      <div
        className={`flex w-full flex-1 flex-col gap-2 md:flex-row md:items-center ${className}`}
      >
        <div className="flex items-center justify-between gap-2">
          <ProfileIcon img="" dimension={32} className="" />
        </div>

        <p className="flex flex-1 flex-wrap items-center gap-0 text-sm text-grey-600">
          <span className="font-bold text-grey-900">{name}</span>
          <span className={`${hideEmailOnMobile && "hidden"} md:flex`}>∙</span>
          <span className={`${hideEmailOnMobile && "hidden"} md:flex`}>
            {email}
          </span>
        </p>

        {showTicket && (
          <div className="hidden flex-wrap gap-1 md:flex">
            {guest?.tickets?.map((t, idx) => {
              const pillColor = ticketColor?.find(
                (tc) => tc.ticketId === (t?.ticketId._id ?? t?.ticketId),
              )?.color;

              return (
                <Pill
                  text={`x${t?.quantity} ${t?.ticketId?.name}`}
                  variation="green"
                  className={``}
                  key={`${t?.ticketId}-${idx}`}
                  style={
                    ticketColor
                      ? {
                          backgroundColor: pillColor
                            ? pillColor?.split(",")[1]
                            : undefined,
                          color: pillColor
                            ? pillColor?.split(",")[0]
                            : undefined,
                        }
                      : undefined
                  }
                />
              );
            })}
          </div>
        )}

        {timeAgo ? (
          <p className="text-sm text-grey-600">{timeAgo}</p>
        ) : undefined}
      </div>

      {showTicket && (
        <div className="flex max-w-max flex-wrap gap-1 md:hidden">
          {guest?.tickets?.map((t, idx) => {
            return (
              <Pill
                key={`${t?.ticketId}-${idx}`}
                text={`x${t?.quantity} ${t?.ticketId?.name}`}
                variation="green"
                className={``}
                style={
                  ticketColor
                    ? {
                        backgroundColor: `color-mix(in srgb, ${
                          ticketColor.find(
                            (tc) =>
                              tc.ticketId === (t?.ticketId?._id ?? t?.ticketId),
                          )?.color
                        } 40%, white)`,
                        color: `${
                          ticketColor.find(
                            (tc) =>
                              tc.ticketId === (t?.ticketId?._id ?? t?.ticketId),
                          )?.color
                        }`,
                      }
                    : undefined
                }
              />
            );
          })}
        </div>
      )}
    </div>
  );
};
